import Tdg_CompanyProfessionListModelBase from '../_generated/modelBases/tdg-company-profession-list-model-base';

export default class Tdg_CompanyProfessionListModel extends Tdg_CompanyProfessionListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
